import React from 'react';

interface StepIndicatorProps {
  currentStep: number;
  totalSteps: number;
  requiresAuth?: boolean;
}

export function StepIndicator({ currentStep, totalSteps, requiresAuth }: StepIndicatorProps) {
  return (
    <div className="flex items-center justify-center mb-8">
      {Array.from({ length: totalSteps }, (_, i) => i + 1).map((step) => (
        <React.Fragment key={step}>
          <div className={`w-8 h-8 rounded-full flex items-center justify-center ${
            currentStep === step ? 'bg-indigo-600 text-white' : 
            currentStep > step ? 'bg-green-500 text-white' : 'bg-gray-200'
          } ${requiresAuth && step >= 5 ? 'ring-2 ring-yellow-400' : ''}`}>
            {currentStep > step ? '✓' : step}
          </div>
          {step < totalSteps && (
            <div className={`w-20 h-1 ${
              currentStep > step ? 'bg-green-500' : 'bg-gray-200'
            }`} />
          )}
        </React.Fragment>
      ))}
    </div>
  );
}